/* eslint-disable max-len */
export const HEADER = {
  TITLE: 'De routekaart Financiële Zorgen',
  CONTENT:
    'Wilt u inwoners met financiële zorgen beter ondersteunen? Kies hieronder de doelgroep en mijlpaal en vind alle beschikbare informatie en hulpmiddelen. Of lees eerst verder om meer te weten over de routekaart.',
  START_SEARCH: 'Start',
  EXPLAINER: 'Wat betekenen deze termen?',
}
